import { MANDATORY_SERVICE_KEYS, MANDATORY_FP_CONFIG_KEYS } from './constants';

export const checkMandatoryServiceKey = (serviceName, parameter) => {
	const mandatoryServiceKeys = MANDATORY_SERVICE_KEYS[serviceName];
	if (!mandatoryServiceKeys) return false;
	if (mandatoryServiceKeys.includes(parameter)) return true;
	return false;
};

export const checkMandatoryFpSplitConfigKey = (engineType, parameter) => {
	const mandatoryServiceKeys = MANDATORY_FP_CONFIG_KEYS[engineType];
	if (!mandatoryServiceKeys) return false;
	if (mandatoryServiceKeys.includes(parameter)) return true;
	return false;
};
